import React, { useState } from "react";
import { View, StyleSheet, Text } from "react-native-web";
import { Button, Progress, Modal } from "antd";
import "antd/dist/antd.css";
import ScrollableTabs from "./ScrollableTabs";
import app from "../base";
import { RightOutlined } from "@ant-design/icons";

const data = [
	{
		active: "Options",
		options: ["Yes", "No"],
		selectedDuration: 0,
		skip: true,
		tabIndex: 0,
		title: "1",
		question: "Did you have a good birthday this year?",
		type: "options",
	},
	{
		active: "Rating",
		options: ["", ""],
		selectedDuration: 0,
		skip: false,
		tabIndex: 1,
		title: "2",
		question: "How many curse words you use in a day?",
		type: "rating",
	},
	{
		active: "Slider",
		count: 10,
		options: ["", ""],
		selectedDuration: 1,
		skip: true,
		tabIndex: 2,
		title: "3",
		question: "How many curse words you use in a day?",
		type: "slider",
	},
	{
		active: "Drop down",
		options: ["Yes", "No", "Maybe"],
		selectedDuration: 0,
		skip: true,
		tabIndex: 3,
		title: "4",
		question: "If you go on a vacation, would you take one of your friend?",
		type: "dropdown",
	},
	{
		active: "Boolean",
		options: ["Yes", "No"],
		selectedDuration: 0,
		skip: true,
		tabIndex: 4,
		title: "5",
		question: "Are you scared of sharks?",
		type: "boolean",
	},
	{
		active: "Boolean",
		options: ["Yes", "No"],
		selectedDuration: 0,
		skip: true,
		tabIndex: 5,
		title: "6",
		question: "Are you technically strong?",
		type: "boolean",
	},
	{
		active: "CheckBox",
		options: ["Yes", "No", "Maybe"],
		selectedDuration: 0,
		skip: true,
		tabIndex: 6,
		title: "7",
		question: "Have your parents ever caught you drinking?",
		type: "check",
	},
	{
		tabIndex: 7,
		title: "8",
		type: "comment",
	},
];

const Content = (props) => {
	const [skip, setSkip] = useState(false);
	const [enableNext, setEnableNext] = useState(true);
	const [enableSubmit, setEnableSubmit] = useState(true);
	const [showSubmit, setShowSubmit] = useState(false);
	const [enablePrev, setEnablePrev] = useState(true);
	const [showPrev, setShowPrev] = useState(false);
	const [formSubmitObj, setFormSubmitObj] = useState([]);
	const [percent, setPercent] = useState(0);
	const [answers, setAnswers] = useState([]);
	const [comment, setComment] = useState("");
	const { questions } = props.currentSurvey;
	const [progressText, setProgressText] = useState(
		`0 / ${questions.length - 1} completed`
	);

	function success() {
		Modal.success({
			content: "Survey completed, thank you!",
			okText: "Sign out",
			onOk: () => app.auth().signOut(),
		});
	}

	const submitData = () => {
		props.submitData(answers, comment);
		success();
	};

	const addCurrentAnswer = (obj, index) => {
		if ((index == 0 && answers.length == 0) || index > answers.length) {
			var currentAnwers = answers.slice();
			currentAnwers.push(obj);
			setAnswers(currentAnwers);
		} else {
			var currentAnwer = answers.slice();
			currentAnwer[index] = obj;
			setAnswers(currentAnwer);
		}
	};

	return (
		<View style={styles.container}>
			<View style={{ alignItems: "center" }}>
				<Text style={{fontFamily: "NunitoSans"}}>{progressText}</Text>
				<Progress percent={percent} style={{ width: 150 }} showInfo={false} />
			</View>
			<ScrollableTabs
				setRef={setRef}
				questionsArr={questions}
				onChange={(selectedTabData, index) => {
					setSkip(selectedTabData.skip);
					setProgressText(`${index} / ${questions.length - 1} completed`);
					setPercent(Math.round((index / (questions.length - 1)) * 100));
					handleFieldChange(
						selectedTabData,
						setEnableSubmit,
						setShowSubmit,
						setEnablePrev,
						setShowPrev
					);
				}}
				formAnswerObject={(selectedTab, obj, index) =>
					addCurrentAnswer(obj, index)
				}
				onNextEnable={(value) => setEnableNext(value)}
				onComment={(value) => setComment(value)}
			/>
			<View style={styles.formContainer}>
				{!showPrev && (
					<Button
						disabled={enablePrev}
						onClick={moveToPrevQuestion}
						type="primary"
						style={{
							borderRadius: 25,
							marginTop: 20,
							height: 40,
							width: 100,
							fontSize: 16,
							fontWeight: "600"
						}}
					>
						Prev
					</Button>
				)}
				{showSubmit && (
					<Button
						type="primary"
						style={{
							borderRadius: 20,
							marginTop: 20,
							height: 40,
							width: 200,
							fontSize: 16,
							fontWeight: "600"
						}}
						disabled={enableSubmit}
						onClick={submitData}
					>
						Submit
					</Button>
				)}
				{!showSubmit && (
					<Button
						type="primary"
						style={{
							borderRadius: 25,
							marginTop: 20,
							marginLeft: 20,
							height: 40,
							width: 100,
							fontSize: 16,
							fontWeight: "600"
						}}
						disabled={enableNext}
						onClick={() => moveToNextQuestion(setEnableNext)}
					>Next</Button>
				)}
				{/* <Button
					type="dashed"
					className="buttonGroups"
					disabled={skip}
					onClick={moveToNextQuestion}
				>
					Skip
				</Button> */}
			</View>
		</View>
	);
};
var tabObj;

const setRef = (tabs) => {
	tabObj = tabs;
};
const moveToNextQuestion = (setEnableNext) => {
	setEnableNext(true);
	tabObj.goToTab(tabObj.nextCurrentTab + 1);
};

const moveToPrevQuestion = () => {
	tabObj.goToTab(tabObj.nextCurrentTab - 1);
};

const handleFieldChange = (
	selecedTab,
	enableSubmit,
	showSubmit,
	enablePrev,
	showPrev
) => {
	if (tabObj.nextCurrentTab == tabObj.props.tabs.length - 1) {
		showSubmit(true);
		showPrev(true);
		enableSubmit(false);
	} else {
		showSubmit(false);
		enableSubmit(true);
	}

	if (tabObj.nextCurrentTab > 0) {
		enablePrev(false);
	} else {
		enablePrev(true);
	}
};

const styles = StyleSheet.create({
	formContainer: {
		height: "45px",
		width: "100%",
		alignItems: "center",
		color: "#FFF",
		display: "-webkit-inline-box",
		textAlign: "center",
		//paddingTop: 50,
	},
	formButtons: {
		width: "10%",
		height: "40px",
		position: "relative",
		bottom: 0,
		margin: "0px",
		backgroundColor: "green",
		alignItems: "center",
		borderRadius: "40%",
		display: "inline",
		margin: "10px",
	},
	container: {
		flex: 1,
		position: "relative",
		padding: "10px",
		// alignItems: "center",
		// justifyContent: "center",
		//borderWidth: 1,
		//borderColor: "#D3D3D3",
		marginTop: "0%",
		marginLeft: "5%",
		marginBottom: "2%",
		marginRight: "5%",
		minHeight: "70vh",
		overflow: "auto",
		display: "inline-block",
	},
	circle_fl: {
		display: "inline-block",
		position: "relative",
		boxSizing: "border-box",
		textDecoration: "none",
		color: "#FFF",
		width: "50px",
		height: "50px",
		lineHeight: "30px",
		padding: "5px",
		fontSize: "25px",
		borderRadius: "50%",
		textAlign: "center",
		verticalAlign: "middle",
		fontFamily: "NunitoSans",
		boxShadow:
			"inset 0 2px 0px rgba(255, 255, 255, 0.25), inset 0 -2px 0px rgba(0, 0, 0, 0.18)",
		transition: ".2s",
	},
	fa: {
		lineHeight: "30px",
	},
});

export default Content;
